$(window).scroll(function () { 
	if ($(this).scrollTop() > 80) {
      $(".site-header").css("position","fixed", "!important");
      $(".site-header").css("background-color","#D65050","!important");
      $(".site-header").css("height","90","!important");
      $(".site-nav>li a").css('color','#fff');
      $(".site-nav>li a:hover").css('color','#D65050');
 	}
    else
    {
		$(".site-header").css("position","fixed", "!important");
        $(".site-header").css("background","none","!important");
      	$(".site-nav>li a").css('color','#fff');
      	$(".site-nav>li a:hover").css('color','#D36055');
	}
});

$(function() {
			
  var Page = (function() {

    var $nav = $( '#nav-dots > span' ),
        slitslider = $( '#slider' ).slitslider( {
          onBeforeChange : function( slide, pos ) {

            $nav.removeClass( 'nav-dot-current' );
            $nav.eq( pos ).addClass( 'nav-dot-current' );

          }
        } ),

        init = function() {

          initEvents();

        },
        initEvents = function() {

          $nav.each( function( i ) {

            $( this ).on( 'click', function( event ) {

              var $dot = $( this );

              if( !slitslider.isActive() ) {

                $nav.removeClass( 'nav-dot-current' );
                $dot.addClass( 'nav-dot-current' );

              }

              slitslider.jump( i + 1 );
              return false;

            } );

          } );

        };

    return { init : init };

  })();

  Page.init();

  /**
				 * Notes: 
				 * 
				 * example how to add items:
				 */

  /*

				var $items  = $('<div class="sl-slide sl-slide-color-2" data-orientation="horizontal" data-slice1-rotation="-5" data-slice2-rotation="10" data-slice1-scale="2" data-slice2-scale="1"><div class="sl-slide-inner bg-1"><div class="sl-deco" data-icon="t"></div><h2>some text</h2><blockquote><p>bla bla</p><cite>Margi Clarke</cite></blockquote></div></div>');

				// call the plugin's add method
				ss.add($items);

				*/

});

//single product page tab
$(document).ready(function(e) {
    $('#description').show();
	$('#additional_information').hide
    //
	$('.description a').css('background-color','#D65050');
	$('.description a').css('color','#fff');
	//
	$('.description a').click(function(){
		$(this).addClass('active');
		$(this).css('background-color','#D65050');
		$(this).css('color','#fff');
		$('.information').removeClass('active');
		$('.information a').css('background-color','#fff');
		$('.information a').css('color','#555');
		
		$('#description').show();
		$('#additional_information').hide();
	});
	$('.information a').click(function(){
		$(this).css('background-color','#D65050');
		$(this).css('color','#fff');
		//
		$('.description a').css('background-color','#fff');
		$('.description a').css('color','#555');
		//
		$(this).addClass('active');
		$('.description').removeClass('active');
		$('#description').hide();
		$('#additional_information').show();
		$('#additional_information').css('display','block');
	});
});
